@if (!hideNavigationMenu()) {
<div *ngIf="menuType === 'horizontal'" class="w-100 desktop-horizontal" id="desktop-nav-div">
  <app-navbar-desktop></app-navbar-desktop>
</div>
<div *ngIf="menuType === 'vertical'" class="w-100 desktop-vertical" id="desktop-nav-div">
  <app-navbar-desktop></app-navbar-desktop>
</div>
}
<div id="desktop-container">
  <div
    [ngClass]="{
      'menutype-vertical': !hideNavigationMenu() && menuType === 'vertical',
      'menutype-horizontal': !hideNavigationMenu() && menuType === 'horizontal'
    }"
    [ngStyle]="{
      'margin-left':
        !hideNavigationMenu() && menuType === 'vertical' ? navBarDesktopConfig?.width + 'px' : '0px'
    }"
  >
    <div [ngStyle]="pageContentStyle">
      <div
        [@pageTransition]="getParams(outlet)"
        (@pageTransition.done)="onTransitionDone()"
        (@pageTransition.start)="onTransitionStart()"
      >
        <finxone-web-frontend-main-widget [ngStyle]="mainWidgetStyling"></finxone-web-frontend-main-widget>
      </div>
    </div>
    <!-- Footer Layout -->
    @if (currentPageDetail?.footerLayoutEnabled ?? false) {
    <finxone-web-frontend-footer-layout
      [id]="LayoutNames.FOOTER_LAYOUT"
      [footerLayoutStyles]="footerLayoutStyles"
    ></finxone-web-frontend-footer-layout>
    }

    <div style="margin-bottom: 3rem"></div>
  </div>
</div>
